import React from "react";
import CommonInputSenha from "../../components/forms/CommonInputSenha";
import CommonInput from "../../components/forms/CommonInput";
import { handleChange } from "../../helpers/handleFormChanges";
import { AppContext } from "../../contexts/AppContext";
import useApi from "../../hooks/useApi";
import AuthApiClient from "../../api/auth";
import ConteudoEsquerda from "./AuthCommon/ConteudoEsquerda";
import FormWrapper from "./AuthCommon/FormWrapper";
import { useLocation } from "react-router-dom";

function Login() {
  const [values, setValues] = React.useState({});
  const { baseUrl, session } = React.useContext(AppContext);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const brand_id = queryParams.get("brand_id");
  const locale_id = queryParams.get("locale_id");
  const return_to = queryParams.get("return_to");
  const timestamp = queryParams.get("timestamp");

  const logarApi = useApi(AuthApiClient.logar);

  //Limpa empresas do armazenamento local
  React.useEffect(() => {
    localStorage.clear("empresas");
  }, []);

  //Faz logout caso haja dados armazenados na sessão
  React.useEffect(() => {
    if (session && Object.keys(session).length !== 0)
      window.location.href = `${baseUrl}logout`;
  }, [baseUrl, session]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("usuario", values?.email);
    formData.append("senha", values?.senha);

    if (brand_id && locale_id && return_to && timestamp) {
      formData.append("brand_id", brand_id);
      formData.append("locale_id", locale_id);
      formData.append("return_to", return_to);
      formData.append("timestamp", timestamp);
    }

    const response = await logarApi.request(formData);
    if (!response) return;
    if (response?.congelada === "true")
      return (window.location.href = baseUrl + "congelada/Congelada");
    if (response?.zendesk) return (window.location.href = response?.url);
    if (response?.empresas)
      localStorage.setItem("empresas", response?.empresas);
    window.location.href = baseUrl + response?.url;
  };

  return (
    <>
      <div className="container-fluid p-0">
        <div className="row g-0">
          <ConteudoEsquerda />
          <FormWrapper>
            <div>
              <h5 className="first-text">Olá, Oranger!</h5>
              <h6 className="second-text mb-3">Faça o login para acessar.</h6>
            </div>
            <div className="mt-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <CommonInput
                    label="E-mail"
                    id="email"
                    value={values.email}
                    onChange={(e) => {
                      handleChange(e, values, setValues);
                    }}
                    placeholder="Digite seu e-mail"
                    auth
                  />
                </div>
                <div className="mb-3">
                  <CommonInputSenha
                    label="Senha"
                    id="senha"
                    value={values.senha}
                    onChange={(e) => {
                      handleChange(e, values, setValues);
                    }}
                    placeholder="Digite sua senha"
                    auth
                  />
                  <div className="mt-1 text-end">
                    <a href={`${baseUrl}UserRecovery`} className="right-footer">
                      Esqueceu sua senha?
                    </a>
                  </div>
                </div>
                <div className="mt-3 mb-3 d-grid right-footer">
                  <button
                    className="btn btn-primary waves-effect waves-light auth-button"
                    type="submit"
                  >
                    Log in
                  </button>
                </div>
              </form>
            </div>
          </FormWrapper>
        </div>
      </div>
    </>
  );
}

export default Login;
